/***
 * File name: index.js
 *
 * Program Description:
 * This file contains all the exports of the meta folder
 *
 * Module Exports:
 * - app
 * - metaMixin
 * - forms
 * - errors
 *
 */
import app from './app'
import forms from './forms'
import errors from './errors'

const metaMixin = {
  data: () => ({
    $meta: {
      app,
      forms,
      errors
    }
  })
}

export {
  app,
  metaMixin,
  forms,
  errors
}
const meta = {
  app,
  errors,
  forms
}

export default meta
